"use strict";
/**
 * React hook to detect whether current device -mobile or desktop
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceDetect = void 0;
var USER_AGENT_SSR = "SSR";

var detectMobileDevice = function detectMobileDevice(userAgent) {
  var isMobile = Boolean(userAgent.match(/Mobi/i));
  return {
    isMobile: isMobile,
    isDesktop: !isMobile
  };
};

var useDeviceDetect = function useDeviceDetect() {
  var userAgent = typeof navigator === "undefined" ? USER_AGENT_SSR : navigator.userAgent;
  return detectMobileDevice(userAgent);
};

exports.useDeviceDetect = useDeviceDetect;